<script>
export default {
    name: "LinesTopLeftFrame"
}
</script>
<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="0 0 337.5 633.7" style="enable-background:new 0 0 337.5 633.7;" xml:space="preserve">
        <path id="Path_1241_3_" class="st0" d="M19.3,633.2H0.5V0.5H337v16.9" fill="none" stroke="#FFFFFF"/>
    </svg>
</template>
